import { render, staticRenderFns } from "./TourLp.vue?vue&type=template&id=c72ab694&scoped=true&"
import script from "./TourLp.vue?vue&type=script&lang=js&"
export * from "./TourLp.vue?vue&type=script&lang=js&"
import style0 from "./TourLp.vue?vue&type=style&index=0&id=c72ab694&prod&scoped=true&lang=scss&"
import style1 from "./TourLp.vue?vue&type=style&index=1&id=c72ab694&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72ab694",
  null
  
)

export default component.exports